import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, pipe } from 'rxjs';
import { LeadModel } from 'src/app/models/clients/leads.model';
import { LeadService } from 'src/app/services/client-services/leads.service';
import { PerformanceReportService } from 'src/app/services/report/performance-report.service';
import { ReportSettingsService } from 'src/app/settings/report-settings/report-settings.service';
import DateUtils from 'src/app/utils/date';

@Component({
  selector: 'app-new-leads-report',
  templateUrl: './new-leads-report.component.html',
  styleUrls: ['./new-leads-report.component.css']
})
export class NewLeadsReportComponent implements OnInit {
  dateUtil = new DateUtils;
  selectedStatus = '';
  public chartOptions = {
    series: [
      {
        name: "counts",
        data: []
      }
    ],
    chart: {
      type: "bar",
      height: 350
    },
    plotOptions: {
      bar: {
        horizontal: false
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: [],
      title: {
        text: 'SalesPerson',
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
        }
      },
    },
    colors: ["rgb(255,177,193))"]
  };
  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: [
        { title:  "Source", key:  "source" },
        { title:  "Value", key:  "sourceValue" },
        { title:  "Creation Date", key:  "createdAt", pipe: "date"}, 
    ],
    rows: null,
    options: {
      debug: false, // change to true if you want to see datatable events
      noOfRowsToDisplay: 3, // change the amount of data you want to display at a particular time
      bulkActions: [],
      singleActions: [],
    }
  }
  dealsData
  years: any[];
  selectedYr = new Date().getFullYear();
  selectedPeriod = 'monthly';
  allReasonList$: Observable<any[]>;
  months = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0 };
  selectedReason = 'All'
  result;
  selectedIds = null; selectedType = null;
  baseCurrency
  unfilteredTableResult: LeadModel[]
  constructor(
    private reportSetSrv: ReportSettingsService,
    private performRepSrv: PerformanceReportService,
    private leadSrv: LeadService,
    ) {
    this.years = this.dateUtil.getYears();
    
    this.performRepSrv.selected_users.subscribe(res => {
      if (res && res.type) {
        const { ids, type } = res;
        this.selectedIds = ids;
        this.selectedType = type;
      }
    })
  }

  ngOnInit() {
    this.getNewLeads();
  }

  getNewLeads() {
    this.dataTable.rows = null;
    this.reportSetSrv.getReportConfig().subscribe(repSet => {
      console.log('repset', repSet)
      const config = repSet ? repSet.newLeadDays : 0;
      const query = this.getQuery(config);      
      this.leadSrv.filterLead(query).subscribe(res => {

        const leads = res.payload.records || [];
        this.unfilteredTableResult = leads.map(data => ({ ...data, createdAt: new Date(data.createdAt).toDateString()}));  
        this.getTableData(leads);
      })
    })
  } 
  private getQuery = (value) => {
    const { getTsByNum, getEndTimeStp } = this.dateUtil;
    const endDate = getEndTimeStp(new Date())
    return `range=${(JSON.stringify({ createdAt: { from: getTsByNum(value), to: endDate } }))}`
  }

  getTableData(leads: LeadModel[]) {
    const result = leads || [];
    this.dataTable.rows = result.map(data => ({ ...data, createdAt: new Date(data.createdAt).toDateString()}));
    this.dataTable.dataChangedObs.next(true); 
  }

}
